import { createBrowserRouter, Navigate } from 'react-router-dom';

import { authRoutes } from './auth.route';
import { adminRoutes } from './admin.route';
import { instructorRoutes } from './instructor.route';
import { studentRoutes } from './student.route';
import { parentRoutes } from './parent.route';
import { staffRoutes } from './staff.route';
import { publicRoutes } from './public.route';
import { attendanceTabletRoutes } from './attendance-tablet.route';

import { useAuthStore } from '@/shared/auth/authStore';
import { PATH, HOME_PATH_BY_ROLE } from '@/shared/constants';

function HomeRedirect() {
  const userInfo = useAuthStore((state) => state.userInfo);
  const isLoggedIn = userInfo.userRole !== '';

  const homePath = (userInfo.userRole && HOME_PATH_BY_ROLE[userInfo.userRole]) ?? PATH.AUTH.SIGNIN;
  const redirectPath = isLoggedIn ? homePath : PATH.AUTH.SIGNIN;

  return <Navigate to={redirectPath} replace />;
}

export const router = createBrowserRouter([
  {
    children: [
      { path: '/', element: <HomeRedirect /> },

      ...authRoutes,
      adminRoutes,
      instructorRoutes,
      studentRoutes,
      parentRoutes,
      staffRoutes,
      publicRoutes,
      attendanceTabletRoutes,

      { path: '*', element: <HomeRedirect /> },
    ],
  },
]);
